/** The company roles live in core-lib's role matrix, shared with the Management Dashboard and zaeper.io. */
export { COMPANY_ROLES, roleAtLeast, TCompanyRole } from "@zaeper/core-lib";
